import styled from 'styled-components';

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 12px;
  padding: ${({ $padding }) => $padding || '0'};
`;

const variantStyles = {
  default: {
    background: 'white',
    color: 'black',
    border: '1px solid #ccc',
  },
  gray: {
    background: '#f7f7f7',
    color: '#333',
    border: '1px solid #ccc',
  },
  orange: {
    background: '#F89B3C',
    color: 'white',
    border: 'none',
  },
  green: {
    background: '#85B33E',
    color: 'white',
    border: 'none',
  },
};

export const Button = styled.button`
    font-weight: 500;
    font-size: 1.2rem;
    border-radius: 5px;
    padding: 10px 20px;
    cursor: pointer;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    transition: background-color 0.2s ease;
    min-width: 110px;
    margin-right: ${({ $marginRight }) => $marginRight || '0'};
   
  ${({ variant = 'default' }) => {
    const style = variantStyles[variant] || variantStyles.default;
    return `
      background-color: ${style.background};
      color: ${style.color};
      border: ${style.border};
    `;
  }}

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    min-width: 90px;
    padding: 8px 16px;
    font-size: 1rem;
  }
`;

// Generic container for vertical toolbars
export const ToolbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

// Generic style for the circular toolbar buttons
export const ToolbarButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #ccc;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;

  background-color: ${({ variant }) => {
    if (variant === 'orange') return '#F89B3C';
    if (variant === 'red') return '#dc3545';
    return 'white'; // Default background
  }};

  color: ${({ variant }) => (variant ? 'white' : '#333')};
  font-weight: ${({ variant }) => (variant ? 'bold' : 'normal')};
  font-size: ${({ variant }) => (variant ? '24px' : '20px')};

  &:hover {
    opacity: 0.9;
  }
`;